import { defineRule } from 'vee-validate'
import { required, email, min, max } from '@vee-validate/rules'

defineRule('required', required)
defineRule('email', email)
defineRule('min', min)
defineRule('max', max)
defineRule('phone', (value) => {
    if (!value) return true
    return /^[0-9]+$/.test(value) || 'Số điện thoại không hợp lệ'
})